angular.module("vgresiduos").controller("CustomReportCreateCtrl", [
	"$rootScope",
	function ($rootScope) {
		"use strict";

		this.$onInit = function () {
			Vgr.util.redirectSingleton($rootScope, "bi/relatorios-personalizados/novo");
		};
	}
]);
